<template>

<div>
	<div v-bind:class="{'green lighten-5': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }" class="pa-3 text-center">
		<v-progress-circular
      indeterminate
      color="success"
      size="18"
    ></v-progress-circular>
    {{ $t('compPendingTx.intro') }}
	</div>
	<div class="text-center mt-3">
		<v-btn tile outlined color="success" class="mt-3" link :href="txurl + txhash" target="_blank">
			{{ $t('compPendingTx.btnViewTx') }} <v-icon right>mdi-open-in-new</v-icon>
		</v-btn>
	</div>
	<v-progress-linear
		active
		indeterminate
		absolute
		bottom
		color="green lighten-3"
	></v-progress-linear>
</div>

</template>

<script>

export default {
	name: 'PendingTransaction',
	props: {
		txhash: { type: String },
		txurl: { type: String },
	},
	data () {
		return {}
	},
	computed: {
		shortTxHash: function () {
			const frontToKeep = 6
			const endToKeep = 4
			const endIndexStart = this.txhash.length - endToKeep
			return this.txhash.substring(0, frontToKeep) + '...' + this.txhash.substring(endIndexStart)
		}
	},
	methods: {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
